import React from 'react';
import styles from './GalleryBanner.module.scss';

const GalleryBanner = <div className={ styles.GalleryBanner }></div>;
 
export default GalleryBanner;